﻿import { bootstrapSheet } from '../../core/styles/bootstrap.js';
import { eumBaseSheet } from '../../core/styles/eum-base.js';
import { i18n } from '../../core/i18n/i18n-service.js';
// @ts-ignore — handled by esbuild inline-css plugin
import componentSheet from './eum-results-meta.css';

/**
 * <eum-results-meta> — displays "Found X results in Y seconds".
 * Driven via attributes: total-count, fetch-time.
 */
export class EumResultsMeta extends HTMLElement {
    private span!: HTMLSpanElement;

    static get observedAttributes(): string[] {
        return ['total-count', 'fetch-time'];
    }

    connectedCallback(): void {
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.adoptedStyleSheets = [bootstrapSheet, eumBaseSheet, componentSheet];

        shadow.innerHTML = /*html*/ `<small class="text-body-secondary"></small>`;

        this.span = shadow.querySelector('small')!;
        this.update();
    }

    attributeChangedCallback(): void {
        if (this.span) this.update();
    }

    private update(): void {
        const total = this.getAttribute('total-count') || '0';
        const time = this.getAttribute('fetch-time') || '';
        this.span.textContent = time
            ? i18n.t('resultsMeta.summary', { count: Number(total), seconds: time })
            : '';
    }

}

customElements.define('eum-results-meta', EumResultsMeta);